import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_item_post_attachment_RowClass, bl_fi_mst_item_post_hdr_RowClass} from '../../../dbschema';


export class FinancialItemPostContainerModel extends BaseContainerModel {
  bl_fi_mst_item_post_hdr: bl_fi_mst_item_post_hdr_RowClass = new bl_fi_mst_item_post_hdr_RowClass();
  bl_fi_mst_item_post_attachments: bl_fi_mst_item_post_attachment_RowClass[] = [];
}
